/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as publicPublicImport } from './routes/(public)/_public'
import { Route as publicPublicIndexImport } from './routes/(public)/_public/index'
import { Route as publicPublicTermsImport } from './routes/(public)/_public/terms'
import { Route as publicPublicPrivacyPolicyImport } from './routes/(public)/_public/privacy-policy'
import { Route as publicPublicDataDeletionImport } from './routes/(public)/_public/data-deletion'
import { Route as publicPublicContactImport } from './routes/(public)/_public/contact'
import { Route as publicPublicAboutImport } from './routes/(public)/_public/about'
import { Route as publicPublicProductsEstmanImport } from './routes/(public)/_public/products/estman'
import { Route as publicPublicProductsAlphaImport } from './routes/(public)/_public/products/alpha'

// Create Virtual Routes

const publicImport = createFileRoute('/(public)')()

// Create/Update Routes

const publicRoute = publicImport.update({
  id: '/(public)',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicRoute = publicPublicImport.update({
  id: '/_public',
  getParentRoute: () => publicRoute,
} as any)

const publicPublicIndexRoute = publicPublicIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicTermsRoute = publicPublicTermsImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicPrivacyPolicyRoute = publicPublicPrivacyPolicyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicDataDeletionRoute = publicPublicDataDeletionImport.update({
  id: '/data-deletion',
  path: '/data-deletion',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicContactRoute = publicPublicContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicAboutRoute = publicPublicAboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicProductsEstmanRoute = publicPublicProductsEstmanImport.update(
  {
    id: '/products/estman',
    path: '/products/estman',
    getParentRoute: () => publicPublicRoute,
  } as any,
)

const publicPublicProductsAlphaRoute = publicPublicProductsAlphaImport.update({
  id: '/products/alpha',
  path: '/products/alpha',
  getParentRoute: () => publicPublicRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(public)': {
      id: '/(public)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicImport
      parentRoute: typeof rootRoute
    }
    '/(public)/_public': {
      id: '/(public)/_public'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicImport
      parentRoute: typeof publicRoute
    }
    '/(public)/_public/about': {
      id: '/(public)/_public/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof publicPublicAboutImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/contact': {
      id: '/(public)/_public/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof publicPublicContactImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/data-deletion': {
      id: '/(public)/_public/data-deletion'
      path: '/data-deletion'
      fullPath: '/data-deletion'
      preLoaderRoute: typeof publicPublicDataDeletionImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/privacy-policy': {
      id: '/(public)/_public/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof publicPublicPrivacyPolicyImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/terms': {
      id: '/(public)/_public/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof publicPublicTermsImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/': {
      id: '/(public)/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicIndexImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/products/alpha': {
      id: '/(public)/_public/products/alpha'
      path: '/products/alpha'
      fullPath: '/products/alpha'
      preLoaderRoute: typeof publicPublicProductsAlphaImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/products/estman': {
      id: '/(public)/_public/products/estman'
      path: '/products/estman'
      fullPath: '/products/estman'
      preLoaderRoute: typeof publicPublicProductsEstmanImport
      parentRoute: typeof publicPublicImport
    }
  }
}

// Create and export the route tree

interface publicPublicRouteChildren {
  publicPublicAboutRoute: typeof publicPublicAboutRoute
  publicPublicContactRoute: typeof publicPublicContactRoute
  publicPublicDataDeletionRoute: typeof publicPublicDataDeletionRoute
  publicPublicPrivacyPolicyRoute: typeof publicPublicPrivacyPolicyRoute
  publicPublicTermsRoute: typeof publicPublicTermsRoute
  publicPublicIndexRoute: typeof publicPublicIndexRoute
  publicPublicProductsAlphaRoute: typeof publicPublicProductsAlphaRoute
  publicPublicProductsEstmanRoute: typeof publicPublicProductsEstmanRoute
}

const publicPublicRouteChildren: publicPublicRouteChildren = {
  publicPublicAboutRoute: publicPublicAboutRoute,
  publicPublicContactRoute: publicPublicContactRoute,
  publicPublicDataDeletionRoute: publicPublicDataDeletionRoute,
  publicPublicPrivacyPolicyRoute: publicPublicPrivacyPolicyRoute,
  publicPublicTermsRoute: publicPublicTermsRoute,
  publicPublicIndexRoute: publicPublicIndexRoute,
  publicPublicProductsAlphaRoute: publicPublicProductsAlphaRoute,
  publicPublicProductsEstmanRoute: publicPublicProductsEstmanRoute,
}

const publicPublicRouteWithChildren = publicPublicRoute._addFileChildren(
  publicPublicRouteChildren,
)

interface publicRouteChildren {
  publicPublicRoute: typeof publicPublicRouteWithChildren
}

const publicRouteChildren: publicRouteChildren = {
  publicPublicRoute: publicPublicRouteWithChildren,
}

const publicRouteWithChildren =
  publicRoute._addFileChildren(publicRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof publicPublicIndexRoute
  '/about': typeof publicPublicAboutRoute
  '/contact': typeof publicPublicContactRoute
  '/data-deletion': typeof publicPublicDataDeletionRoute
  '/privacy-policy': typeof publicPublicPrivacyPolicyRoute
  '/terms': typeof publicPublicTermsRoute
  '/products/alpha': typeof publicPublicProductsAlphaRoute
  '/products/estman': typeof publicPublicProductsEstmanRoute
}

export interface FileRoutesByTo {
  '/about': typeof publicPublicAboutRoute
  '/contact': typeof publicPublicContactRoute
  '/data-deletion': typeof publicPublicDataDeletionRoute
  '/privacy-policy': typeof publicPublicPrivacyPolicyRoute
  '/terms': typeof publicPublicTermsRoute
  '/': typeof publicPublicIndexRoute
  '/products/alpha': typeof publicPublicProductsAlphaRoute
  '/products/estman': typeof publicPublicProductsEstmanRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(public)': typeof publicRouteWithChildren
  '/(public)/_public': typeof publicPublicRouteWithChildren
  '/(public)/_public/about': typeof publicPublicAboutRoute
  '/(public)/_public/contact': typeof publicPublicContactRoute
  '/(public)/_public/data-deletion': typeof publicPublicDataDeletionRoute
  '/(public)/_public/privacy-policy': typeof publicPublicPrivacyPolicyRoute
  '/(public)/_public/terms': typeof publicPublicTermsRoute
  '/(public)/_public/': typeof publicPublicIndexRoute
  '/(public)/_public/products/alpha': typeof publicPublicProductsAlphaRoute
  '/(public)/_public/products/estman': typeof publicPublicProductsEstmanRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact'
    | '/data-deletion'
    | '/privacy-policy'
    | '/terms'
    | '/products/alpha'
    | '/products/estman'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/contact'
    | '/data-deletion'
    | '/privacy-policy'
    | '/terms'
    | '/'
    | '/products/alpha'
    | '/products/estman'
  id:
    | '__root__'
    | '/(public)'
    | '/(public)/_public'
    | '/(public)/_public/about'
    | '/(public)/_public/contact'
    | '/(public)/_public/data-deletion'
    | '/(public)/_public/privacy-policy'
    | '/(public)/_public/terms'
    | '/(public)/_public/'
    | '/(public)/_public/products/alpha'
    | '/(public)/_public/products/estman'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  publicRoute: typeof publicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  publicRoute: publicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(public)"
      ]
    },
    "/(public)": {
      "filePath": "(public)",
      "children": [
        "/(public)/_public"
      ]
    },
    "/(public)/_public": {
      "filePath": "(public)/_public.tsx",
      "parent": "/(public)",
      "children": [
        "/(public)/_public/about",
        "/(public)/_public/contact",
        "/(public)/_public/data-deletion",
        "/(public)/_public/privacy-policy",
        "/(public)/_public/terms",
        "/(public)/_public/",
        "/(public)/_public/products/alpha",
        "/(public)/_public/products/estman"
      ]
    },
    "/(public)/_public/about": {
      "filePath": "(public)/_public/about.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/contact": {
      "filePath": "(public)/_public/contact.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/data-deletion": {
      "filePath": "(public)/_public/data-deletion.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/privacy-policy": {
      "filePath": "(public)/_public/privacy-policy.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/terms": {
      "filePath": "(public)/_public/terms.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/": {
      "filePath": "(public)/_public/index.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/products/alpha": {
      "filePath": "(public)/_public/products/alpha.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/products/estman": {
      "filePath": "(public)/_public/products/estman.tsx",
      "parent": "/(public)/_public"
    }
  }
}
ROUTE_MANIFEST_END */
